class Liquidacion {
  constructor(idLiquidacion,nroFactura, nroRecibo, fechaEntrada, fechaVencimiento, procesoJudicial,trabajador,prestador,estado,importe,anioFiscal,nroGestion,cbuPiscys,cbuPiscysNumerico,expediente,idJuicio,conceptoLetrado){
    this.idLiquidacion=idLiquidacion
    this.nroFactura=nroFactura
    this.nroRecibo=nroRecibo
    this.fechaEntrada=fechaEntrada
    this.fechaVencimiento=fechaVencimiento
    this.procesoJudicial=procesoJudicial
    this.trabajador=trabajador
    this.prestador=prestador
    this.estado=estado
    this.importe=importe
    this.anioFiscal=anioFiscal
    this.nroGestion=nroGestion
    this.cbuPiscys=cbuPiscys
    this.cbuPiscysNumerico=cbuPiscysNumerico
    this.expediente=expediente
    this.idJuicio=idJuicio 
    this.conceptoLetrado=conceptoLetrado 
  }
}

export default Liquidacion
